import { Injectable } from "@angular/core";

import { AppLauncher } from "@capacitor/app-launcher";

import { Platform } from "@ionic/angular";
import {
  InAppBrowser,
  InAppBrowserOptions,
} from "@ionic-native/in-app-browser/ngx";

@Injectable({
  providedIn: "root",
})
export class UtilsService {
  inAppOptions: InAppBrowserOptions = {
    location: "no",
    hidden: "no",
    clearcache: "yes",
    clearsessioncache: "yes",
    closebuttoncaption: "Fechar",
    toolbar: "yes",
  };

  constructor(private platform: Platform, private inAppBrowser: InAppBrowser) {}

  openSocialProfile(type, profile) {
    switch (type) {
      case "instagram":
        this.launchExternalApp(
          "instagram://",
          "com.instagram.android",
          "user?username=",
          "https://www.instagram.com/",
          profile
        );
        break;
      case "fb":
        this.launchExternalApp(
          "fb://",
          "com.facebook.katana",
          "faceweb/f?href=https://www.facebook.com/",
          "https://www.facebook.com/",
          profile
        );
        break;
      case "wpp":
        this.launchExternalApp(
          "whatsapp://",
          "com.whatsapp",
          "send?phone=55",
          "https://api.whatsapp.com/send?phone=55",
          profile.replace(/[^0-9]/g, "")
        );
        break;
      case "whatsapp":
        this.launchExternalApp(
          "whatsapp://",
          "com.whatsapp",
          "send?phone=55",
          "https://api.whatsapp.com/send?phone=55",
          profile.replace(/[^0-9]/g, "")
        );
        break;
    }
  }

  async launchExternalApp(
    iosSchemaName: string,
    androidPackageName: string,
    appUrl: string,
    httpUrl: string,
    username: string
  ) {
    let url: string;
    if (this.platform.is("ios")) {
      url = iosSchemaName;
    } else if (this.platform.is("android")) {
      url = androidPackageName;
    } else {
      const browser = this.inAppBrowser.create(
        httpUrl + username,
        "_system",
        "location=yes"
      );
    }

    const { value } = await AppLauncher.canOpenUrl({ url });

    if (value && this.platform.is("ios")) {
      const browser = this.inAppBrowser.create(
        appUrl + username,
        "_system",
        this.inAppOptions
      );
    } else {
      const browser = this.inAppBrowser.create(
        httpUrl + username,
        "_system",
        "location=yes"
      );
    }
  }

  getVimeoPictureUrl(pictureUrl) {
    const strReplace = "/pictures/";

    const indexPictureId = pictureUrl.indexOf(strReplace);

    const pictureId = pictureUrl.slice(indexPictureId + strReplace.length);
    return `https://i.vimeocdn.com/video/${pictureId}_640x360.jpg?r=pad`;
  }
}
